import React from "react";
import {
    BarChart,
    Bar,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
    LabelList,
    ResponsiveContainer,
    Cell
} from "recharts";
import { formatVisibleNumber, getEvaluationScoreColor } from '../components/selfcare360/selfcare360Scales';


const ByOrgItemBarChart = ({ data, redLight, yellowLight, serviceId }) => {
    if (!data) return null;

    const getColor = (value) => {
        return getEvaluationScoreColor(value, { redLight, yellowLight, serviceId });
    };

    const renderValueLabel = (props) => {
        const { x, y, width, height, value } = props;
        const v = Number(value);

        const cx = (x || 0) + (width || 0);
        const cy = (y || 0) + (height || 0) / 2;

        return (
            <text
                x={cx + 8}
                y={cy}
                fill="#334155"
                fontSize={11}
                fontWeight={'bold'}
                dominantBaseline="middle"
                textAnchor="start"
            >
                {`${formatVisibleNumber(Number.isFinite(v) ? v : 0)}%`}
            </text>
        );
    };

    const parsedData = data.map((item, index) => {
        const value = Number(item.average);
        return {
        id: index, // o puedes usar un identificador más específico si lo hay
        name: `${item.name}`,
            value,
            color: getColor(value),
        };
    });

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            const value = payload[0].value;
            return (
                <div style={{ backgroundColor: 'white', padding: 10, border: '1px solid #ccc', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', maxWidth: 400 }}>
                    <span><strong>{label}</strong></span>
                    <span style={{ color: '#3E246B', fontWeight: 500 }}>{formatVisibleNumber(value)}%</span>
                </div>
            );
        }
        return null;
    };

    return (
        <ResponsiveContainer width="100%" height={Math.max(parsedData.length > 5 ? parsedData.length * 30 : parsedData.length > 2 ? parsedData.length * 40 : parsedData.length * 70, 220)}>
            <BarChart
                data={parsedData}
                layout="vertical"
                margin={{ top: 14, right: 44, left: 0, bottom: 0 }}
            >
                <CartesianGrid horizontal={false} stroke="#dbe4ef" />
                <XAxis
                    type="number"
                    domain={[0, 100]}
                    orientation="top"
                    ticks={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
                    tickFormatter={(tick) => `${tick}%`}
                    tick={{ fontSize: 9, fill: '#94a3b8' }}
                    tickLine={false}
                    axisLine={false}
                    height={22}
                />
                <YAxis
                    type="category"
                    dataKey="name"
                    width={250}
                    tick={{ fontSize: 10, fill: '#475569' }}
                    tickLine={false}
                    axisLine={false}
                />
                <Tooltip 
                    content={<CustomTooltip />} 
                    wrapperStyle={{ zIndex: 1000 }}
                />
                <Bar dataKey="value" barSize={16} radius={[0, 8, 8, 0]}>
                    {parsedData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                    <LabelList
                        dataKey="value"
                        content={renderValueLabel}
                    />
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
};

export default ByOrgItemBarChart;
